export default __webpack_public_path__ + "static/media/ATR@3x.31e51c16.png";